import { iframeResizer } from 'iframe-resizer';

export const autoResizeHeight = (iframeId) => {
    iframeResizer({checkOrigin: false}, document.querySelector(iframeId));
};
